var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

//  @jsx h

import { h } from 'preact';
import PureComponent from '../../lib/preact-pure-component';
import warn from '../../lib/warn';
import Scrubber from './Scrubber';
import TogglePlayButton from './TogglePlayButton';
import ToggleMuteButton from './ToggleMuteButton';
var style = {
  'videoPlayer': 'dhfc-1_0_0-beta_28-videoPlayer',
  'videoPlayer__container': 'dhfc-1_0_0-beta_28-videoPlayer__container',
  'videoPlayer__caption': 'dhfc-1_0_0-beta_28-videoPlayer__caption',
  'videoPlayer__controls': 'dhfc-1_0_0-beta_28-videoPlayer__controls',
  'videoPlayer__togglePlayButton': 'dhfc-1_0_0-beta_28-videoPlayer__togglePlayButton',
  'videoPlayer__toggleMuteButton': 'dhfc-1_0_0-beta_28-videoPlayer__toggleMuteButton'
};

var VideoPlayer = function (_PureComponent) {
  _inherits(VideoPlayer, _PureComponent);

  function VideoPlayer() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, VideoPlayer);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = VideoPlayer.__proto__ || Object.getPrototypeOf(VideoPlayer)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      caption: null,
      duration: 0,
      isPlaying: false,
      time: 0
    }, _this.handleUserTogglePlay = function () {
      _this.props.onUserTogglePlay();
    }, _this.handleUserToggleMute = function () {
      _this.props.onUserToggleMute();
    }, _this.handleScrubberPositionUpdate = function (position) {
      if (_this.video) {
        _this.video.seek(_this.state.duration * position);
      } else {
        warn('[@nrk/dh-feature-components] No video reference');
      }
    }, _this.handleCaptionCueEnter = function (caption) {
      _this.setState({ caption: caption });
    }, _this.handleCaptionCueExit = function () {
      _this.setState({ caption: null });
    }, _this.handleDurationChange = function (duration) {
      _this.setState({ duration: duration });
    }, _this.handlePlay = function () {
      var onPlay = _this.props.onPlay;


      _this.setState({ isPlaying: true });

      if (onPlay) {
        onPlay();
      }
    }, _this.handlePause = function () {
      var onPause = _this.props.onPause;


      _this.setState({ isPlaying: false });

      if (onPause) {
        onPause();
      }
    }, _this.handleTimeupdate = function (time) {
      _this.setState({ time: time });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(VideoPlayer, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          muted = _props.muted,
          playing = _props.playing,
          video = _props.video;
      var _state = this.state,
          caption = _state.caption,
          duration = _state.duration,
          isPlaying = _state.isPlaying,
          time = _state.time;


      if (!video.attributes) {
        throw new Error('The `video` property must be a virtual node');
      }

      var className = '' + style.videoPlayer + (this.props.className ? ' ' + this.props.className : '');

      video.attributes.muted = muted;
      video.attributes.playing = playing;
      video.attributes.playsInline = true;
      video.attributes.ref = function (video) {
        return _this2.video = video;
      };
      video.attributes.onPlay = this.handlePlay;
      video.attributes.onPause = this.handlePause;
      video.attributes.onCaptionCueEnter = this.handleCaptionCueEnter;
      video.attributes.onCaptionCueExit = this.handleCaptionCueExit;
      video.attributes.onDurationChange = this.handleDurationChange;
      video.attributes.onTimeupdate = this.handleTimeupdate;

      return h(
        'div',
        { className: className },
        h(
          'div',
          { className: style.videoPlayer__container },
          video,
          caption && h(
            'div',
            { className: style.videoPlayer__caption, 'aria-hidden': 'true' },
            caption.text.split('\n').map(function (text, idx) {
              return h(
                'div',
                { key: String(idx) },
                h('span', { dangerouslySetInnerHTML: { __html: text } })
              );
            })
          ),
          h(
            'div',
            { className: style.videoPlayer__controls },
            h(TogglePlayButton, {
              className: style.videoPlayer__togglePlayButton,
              playing: isPlaying,
              onClick: this.handleUserTogglePlay
            }),
            h(Scrubber, {
              time: time,
              duration: duration,
              onPositionUpdate: this.handleScrubberPositionUpdate
            }),
            h(ToggleMuteButton, {
              className: style.videoPlayer__toggleMuteButton,
              muted: muted,
              onClick: this.handleUserToggleMute
            })
          )
        )
      );
    }
  }]);

  return VideoPlayer;
}(PureComponent);

export default VideoPlayer;